module.exports = " <div v-on:click=favoriteAction(id) class=favoritemark> <span v-if=label class=favoritemark__text>お気に入り</span> <i v-bind:class=\"{'icon2_favorite': fav, 'icon2_add_to_favorite': !fav}\" class=favoritemark__icon title=お気に入り></i> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/favorite_action.vue
// module id = 246
// module chunks = 3